import { Select, message } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import "../../styles/compareWizard.css";
import FileDropzone from "../generic/FileDropzone";
import StepFooter from "./StepFooter";
import {
  checkDate,
  checkFirstRowForEmptyColumn,
  checkNumeric,
  getDelimiter,
  getFirstRow,
} from "../../helper/file_helper";
import { getAllConnection } from "../../service/db.service";

const { Option } = Select;
function UploadFile(props) {
  const type = props.compareType;
  const index = type === "db" ? 2 : 3;
  const previousVisible = type === "db" ? false : true;
  const [file, setFile] = useState();
  const [fileContent, setFileContent] = useState("");
  const [fileType, setFileType] = useState("");

  const onClickNext = () => {
    let delimiter = getDelimiter(fileContent);
    let isEmpty = checkFirstRowForEmptyColumn(fileContent, fileType);
    let header = [1, 2, 3];
    header = getFirstRow(fileContent, delimiter);
    console.log(header);
    let isNumeric = checkNumeric(fileContent, delimiter);
    let isDate = checkDate(fileContent, delimiter);

    if (delimiter !== fileType) {
      message.error("Check if the file delimiter matches the selection.");
    } else if (isEmpty) {
      message.error(
        "Check if the header is empty or if one of the column name is blank"
      );
    } else if (isNumeric || isDate) {
      message.error(
        "Check if there is a numeric or a date value in the header"
      );
    } else {
      getAllConnection().then((res) => {
        console.log("Header::", header);
        props.clickNext(index, file, res.data, header, fileType);
      });
    }
  };

  const getContent = (fileObject) => {
    if (fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFileContent(e.target.result);
      };
      reader.onerror = (e) => {
        console.error("Error reading file:", e.target.error);
      };
      reader.readAsText(fileObject);
    } else {
      console.log("No file selected");
    }
  };
  const onClickBack = () => {
    props.clickPrevious(1);
  };
  return (
    <div className="cmp-pane">
      <div className="cmp-note">
        <InfoCircleOutlined className="cmp-note-icon" />
        <span>
          First row must be the column names — no blank, numeric, or date
          headers.
        </span>
      </div>

      <div className="cmp-block">
        <span className="cmp-field-label">Upload test file</span>
        <FileDropzone
          onFile={(f) => {
            getContent(f);
            setFile(f);
          }}
          accept=".csv,.txt"
          hint="CSV, pipe, or tab-delimited text file"
        />
      </div>

      <div className="cmp-field">
        <span className="cmp-field-label">File delimiter</span>
        <Select
          placeholder="select delimiter"
          onChange={(e) => setFileType(e)}
          style={{ width: "100%" }}
        >
          <Option value="comma">Comma delimited</Option>
          <Option value="pipe">Pipe delimited</Option>
          <Option value="tab">Tab delimited</Option>
        </Select>
      </div>

      <StepFooter
        showBack={previousVisible}
        onBack={onClickBack}
        onNext={onClickNext}
      />
    </div>
  );
}

export default UploadFile;
